import React from "react";

const ProductCard = ({ img, price, title }) => {
  return (
    <div className="bg-white h-full p-3 rounded cursor-pointer hover:scale-105 transition-all">
      <div className="h-[250px] w-full rounded object-cover ">
        <img
          src={img}
          alt=""
          className="rounded h-full w-full object-cover "
          loading="lazy"
        />
      </div>
      <div className="flex justify-between py-3">
        <h1 className="text-lg ">{title}</h1>
        <h3 className="font-bold  text-lg">$ {price}</h3>
      </div>
      <p className="text-gray-600 pb-3">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi
        ratione{" "}
      </p>
    </div>
  );
};

export default ProductCard;
